import * as actionTypes from './actionTypes';

export function getProviderByServiceSiteId(serviceSiteId: number) {
	return {
		type: actionTypes.PROVIDER_DETAILS,
		payload: {
			request: {
				method: 'get',
				url: `provider/${serviceSiteId}/details`
			}
		}
	};
}
